import { Office } from '@/types/office'
import { SocialMediaAccount } from '@/types/socialMediaPlatform'
import { mergeConfig } from '@/util/mergeConfig'
import { socialMediaAccounts } from './socialMediaAccounts'

export interface OfficeI18n {
  // Skip the event picker and let the server match the sign-up to an event by
  // date and postcode (or IP location). Unmatched sign-ups stay unattributed.
  autoMatchEvent: boolean
  socialMedia: SocialMediaAccount[]
  thankYou: {
    displayCreationMagazineButton: boolean
  }
}

const defaultConfig: OfficeI18n = {
  autoMatchEvent: false,
  socialMedia: [
    socialMediaAccounts.instagram,
    socialMediaAccounts.youtube,
    socialMediaAccounts.facebook,
    socialMediaAccounts.twitter,
  ],
  thankYou: {
    displayCreationMagazineButton: false,
  },
}

const officeConfig: Record<Office, Partial<OfficeI18n>> = {
  au: {
    thankYou: {
      displayCreationMagazineButton: true,
    },
  },
  us: {
    autoMatchEvent: true,
  },
  ca: {
    socialMedia: [
      socialMediaAccounts.instagram,
      socialMediaAccounts.youtube,
      socialMediaAccounts.facebook,
      socialMediaAccounts.twitter,
    ],
  },
  uk: {},
  nz: {},
  za: {},
  sg: {
    thankYou: {
      displayCreationMagazineButton: true,
    },
  },
}

export const officeI18n = (office: Office): OfficeI18n => {
  const config = officeConfig[office]
  return config ? mergeConfig(config, defaultConfig) : defaultConfig
}
